module.exports = __webpack_public_path__ + "media/src/images/top_covers/6komorebi-c295fdb3b8d3cf8d165604ceac87ff22.png";